module.exports = __webpack_public_path__ + "bc89dea65abd5d770fe707ad33d1c111.png";